function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.type = "text/javascript";
        script.async = true;

        script.onload = () => resolve(`Script loaded: ${src}`);
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

        document.head.appendChild(script);
    });
}

function reinitializeScript(src) {
    const existingScript = document.querySelector(`script[src="${src}"]`);

    if (existingScript) {
        existingScript.remove();
    }

    return loadScript(src);
}

document.addEventListener("click", (event) => {
    if (event.target.closest("[data-product-options]")) {
        const atcBtn = document.querySelector("button.product--add-to-cart-button");
        const oosForm = document.getElementById("esc-oos-form");

        if (atcBtn && !atcBtn.disabled) {
            oosForm.style.display = "none";
        } else {
            const scriptSrc = "https://d3p29gcwgas9m8.cloudfront.net/assets/js/index.js";

            setTimeout(() => {
                reinitializeScript(scriptSrc)
                    .then(() => {
                        setTimeout(() => oosForm.style.display = "block", 100);
                    })
                    .catch(err => console.error("Widget failed to initialize:", err));
            }, 300);
        }
    }
});